/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "src",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "guy",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "wad",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "wad",
                type: "uint256",
            },
        ],
        name: "Deposit",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "src",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "wad",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "src",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "wad",
                type: "uint256",
            },
        ],
        name: "Withdrawal",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "guy",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "wad",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "deposit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "wad",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "src",
                type: "address",
            },
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "wad",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "wad",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class WETH9__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_name, _symbol, overrides) {
        return super.deploy(_name, _symbol, overrides || {});
    }
    getDeployTransaction(_name, _symbol, overrides) {
        return super.getDeployTransaction(_name, _symbol, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
WETH9__factory.bytecode = _bytecode;
WETH9__factory.abi = _abi;
